"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AppSlogan = react_1.memo(function (_a) {
    var title = _a.title, text = _a.text, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'secondary' : _b, _c = _a.backgroundType, backgroundType = _c === void 0 ? 'first' : _c;
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.image_box, styles_module_scss_1.default[backgroundColor]) },
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.image, styles_module_scss_1.default["image_" + backgroundType]) },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, text))));
});
exports.default = AppSlogan;
